import {PropsWithChildren, ReactNode} from 'react';
import {Tooltip, useTheme} from '@mui/material';
import {styled} from '@mui/material/styles';

import InfoIcon from 'components/icons/info.svg';

const SRoot = styled('div')(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const SelectedTooltip = ({
  children,
  title,
}: PropsWithChildren<{
  title: ReactNode;
}>) => {
  const theme = useTheme();

  return (
    <Tooltip
      title={title}
      slotProps={{
        tooltip: {
          sx: theme => ({
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.common.white,
            color: theme.palette.text.primary,
            borderRadius: 2,
          }),
        },
      }}
    >
      <SRoot>
        {children}
        {title && <InfoIcon width={16} height={16} color={theme.palette.icon.secondary} />}
      </SRoot>
    </Tooltip>
  );
};
